import React from 'react'
import { useEffect, useState } from 'react'
// import Zendesk from 'react-zendesk'
import { useLoadingContext } from '../../../context/spinnerContext'

const Chat = () => {
    const [hasChatLoaded, setHasChatLoaded] = useState<boolean>(false)
    const loadingContext = useLoadingContext()
    const zendeskKey = process.env.REACT_APP_ZENDESK_KEY || ''
    useEffect(() => {
        if (hasChatLoaded) {
            loadingContext?.onClose()
        } else {
            loadingContext?.onOpen()
        }
    }, [])

    // useEffect(() => {
    //     // Asegúrate de colocar esto en un archivo .js separado o en el index.html
    //     const script = document.createElement('script')
    //     script.src = `https://static.zdassets.com/ekr/snippet.js?key=${process.env.REACT_APP_ZENDESK_KEY}` // Reemplaza 'tu_clave' con tu clave de Zendesk
    //     script.async = true
    //     document.body.appendChild(script)

    //     return () => {
    //         document.body.removeChild(script)
    //     }
    // }, [])

    useEffect(() => {
        // Cargar el script de Zendesk
        const script = document.createElement('script')
        script.id = 'ze-snippet'
        script.src =
            'https://static.zdassets.com/ekr/snippet.js?key=3fe29411-2906-45a1-9e08-298238ce054c'
        script.async = true
        document.body.appendChild(script)

        // Lógica para abrir el chat
        const openChat = () => {
            if (document.getElementsByTagName('iframe')[0]) {
                // Aquí se usa zE solo si el script de Zendesk está cargado
                if (window.zE) {
                    window.zE('messenger', 'open')
                }
            } else {
                setTimeout(() => {
                    openChat()
                }, 500)
            }
        }

        // Espera a que el script esté cargado
        script.onload = () => {
            openChat()
        }

        return () => {
            // Limpiar el script al desmontar el componente
            document.body.removeChild(script)
        }
    }, [])
    // const openChat = () => {
    // 	if (document.getElementsByTagName("iframe")[0]) {
    // 		zE("messenger", "open");

    // 	} else {
    // 		setTimeout(() => {
    // 			openChat();
    // 		}, 500);
    // 	}
    // };

    return (
        // <Zendesk
        //     defer
        //     zendeskKey={zendeskKey}
        //     onLoaded={() => setHasChatLoaded(true)}
        // />
        <div></div>
    )
}
export default Chat
